/**
 * Shared password strength rules (CWE-521).
 * Used when setting / changing / resetting passwords — not for login.
 */

export const PASSWORD_MIN_LENGTH = 8;

export const PASSWORD_RULES_HELP =
  "Min 8 characters, with uppercase, lowercase, number, and special character (!@#$%^&* etc.)";

/**
 * Validate that a password meets strong policy.
 * @param {string} password
 * @returns {{ isValid: boolean, message: string }}
 */
export const validateStrongPassword = (password) => {
  const value = password == null ? "" : String(password);

  if (!value.trim()) {
    return { isValid: false, message: "Password is required" };
  }

  if (value.length < PASSWORD_MIN_LENGTH) {
    return {
      isValid: false,
      message: `Password must be at least ${PASSWORD_MIN_LENGTH} characters long`,
    };
  }

  if (!/[A-Z]/.test(value)) {
    return {
      isValid: false,
      message: "Password must include at least one uppercase letter (A-Z)",
    };
  }

  if (!/[a-z]/.test(value)) {
    return {
      isValid: false,
      message: "Password must include at least one lowercase letter (a-z)",
    };
  }

  if (!/[0-9]/.test(value)) {
    return {
      isValid: false,
      message: "Password must include at least one number (0-9)",
    };
  }

  if (!/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~]/.test(value)) {
    return {
      isValid: false,
      message:
        "Password must include at least one special character (!@#$%^&* etc.)",
    };
  }

  return { isValid: true, message: "" };
};

export default {
  PASSWORD_MIN_LENGTH,
  PASSWORD_RULES_HELP,
  validateStrongPassword,
};
